import { Component, Input, OnInit } from '@angular/core';
import { FormViewComponent } from 'src/app/dynamic-forms/form-view/form-view.component';
import { action } from 'src/app/interfaces/action';
import { CardView } from 'src/app/interfaces/cardview';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { MeliNewWizardComponent } from '../meli/meli-new-wizard/meli-new-wizard.component';
import { MeliEditFormComponent } from './meli-edit-form/meli-edit-form.component';

@Component({
    selector: 'app-mercadolivre',
    templateUrl: './mercadolivre.component.html',
    styleUrls: ['./mercadolivre.component.css'],
    standalone: false
})
export class MercadolivreComponent implements OnInit {


  criacaoProduto = MeliNewWizardComponent;//MeliEditFormComponent;
  @Input() parentRow:CardView;
  condition:string;
  ngOnInit(): void {
    if ( ObjectUtil.isNotEmpty(this.parentRow)){
      this.condition = `codecontract=${this.parentRow.linha['CODECONTRACT']} and codeproduct=${this.parentRow.linha['CODEPRODUCT']}`
    }
  }

}


